var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#6728FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.357 5L9.357 9.357 5 9.357 5 10.643 9.357 10.643 9.357 15 10.643 15 10.643 10.643 15 10.643 15 9.357 10.643 9.357 10.643 5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFollow);
export default __webpack_public_path__ + "static/media/ic_follow.7c7af26460b8dbe47acd722162d14826.svg";
export { ForwardRef as ReactComponent };